/* ---------------------------------------------------
	Tools helper
-------------------------------------------------- */

// Gets a character string expressing the input byte count in an appropriate human readable unit, rounded to the n nearest decimals (ex: 1234, 2 -> "1.23KB")
export function getFormattedFileSize(byteCount, decimals, withoutUnit = false) {
    if (0 === byteCount) {
        return "0 Bytes";
    }
    var c = 1024, d = decimals || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], f = Math.floor(Math.log(byteCount) / Math.log(c));
    return parseFloat((byteCount / Math.pow(c, f)).toFixed(d)) + (withoutUnit ? "" : " " + e[f]);
}

// Replace predefined occurences of the input tool success message with the values of the input tool processing result
export function formatToolSuccessMessage(toolSuccessMessage, toolProcessingResult) {
    var formattedMessage = toolSuccessMessage;
    if (toolProcessingResult) {
        formattedMessage = formattedMessage.replace("#input_size", getFormattedFileSize(toolProcessingResult.inputSize, 2));
        formattedMessage = formattedMessage.replace("#output_size", getFormattedFileSize(toolProcessingResult.outputSize, 2));
        formattedMessage = formattedMessage.replace("#size_ratio", (100 - Math.round((toolProcessingResult.outputSize / toolProcessingResult.inputSize * 100))) * 100 / 100);
    }

    return formattedMessage;
}